import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import { Scrollbars } from "react-custom-scrollbars";

type Props = {
  name: string;
  label: string;
  options: Array<{ value: string; label: string }>;
  disabled?: boolean;
  selectedValue?: string;
  key?: string;
  changeHandler?: (e:any) => void;
  menuMaxHeight?: number,
  defaultValue?: any
  value?: any
  sx?: any
};

const slotProps: any = {
  select: {
    MenuProps: {
      PaperProps: {
        sx: {
          maxHeight: 250,
          "&::-webkit-scrollbar": {
            width: "0.3em",
          },
          "&::-webkit-scrollbar-track": {
            background: "#f1f1f1",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#999",
          },
          "&::-webkit-scrollbar-thumb:hover": {
            background: "#555",
          },
        }
      }
    }
}}

const  FieldInputSelect2 = ({ name, label, options, disabled, changeHandler, value = '' }: Props) => {
  return (
    <TextField
      select
      value={value}
      //defaultValue={value}
      slotProps={slotProps}
      onChange={(e) => {
        changeHandler && changeHandler(e);
      }}
      // onChange={onChange}
      label={label}
      //size="small"
      fullWidth
      disabled={disabled}
    >
          {options && options.map((option, idx) => (
            <MenuItem 
              key={`option-${idx}-${option.value}`} 
              //selected={selectedValue && selectedValue === option.value ? true : false} 
              value={option.value}
            >
              {option.label}
            </MenuItem>
          ))}
    </TextField>
  );
}

export default FieldInputSelect2;
